import React, { FC } from 'react';
import { TemplateMediaContainer } from '../TemplateMediaContainer/TemplateMediaContainer';
import { InspirationalTemplate } from '../../domain/entities/inspirationalTemplate';
import { useOnViewportEnter } from '../../hooks/useOnViewportEnter';
import { useMediaLoading } from '../../hooks/useMediaLoading';

export type TemplateVideoProps = {
  className?: string;
  template: InspirationalTemplate;
  index?: number;
  categorySlug?: string;
};

export const TemplateVideo: FC<TemplateVideoProps> = ({
  template,
  className,
  index,
  categorySlug,
}) => {
  const { onMediaLoadStart, onMediaLoaded, isMediaLoading } = useMediaLoading();

  const videoRef = useOnViewportEnter<HTMLVideoElement>(
    (ref) => {
      ref.current?.play();
    },
    {
      threshold: 0,
    },
  );

  return (
    <TemplateMediaContainer
      template={template}
      categorySlug={categorySlug}
      index={index}
      isLoading={isMediaLoading}
      onMouseEnter={() => videoRef.current?.pause()}
      onMouseLeave={() => videoRef.current?.play()}
    >
      <video
        src={template.thumbnailUrl}
        className={className}
        preload="none"
        ref={videoRef}
        muted
        loop
        playsInline
        onLoadedData={onMediaLoaded}
        onLoadStart={onMediaLoadStart}
      />
    </TemplateMediaContainer>
  );
};
